import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_104_222)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M11.2257 0.440629C11.6753 -0.000171555 12.4043 -0.000171616 12.8539 0.440629L16.5988 4.11207C17.0484 4.55287 17.0484 5.26755 16.5988 5.70835C16.1492 6.14916 15.4202 6.14916 14.9706 5.70835L11.2257 2.03691C10.7761 1.59611 10.7761 0.88143 11.2257 0.440629Z",
				fill: "#68DCE3"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M18.2272 7.30464C18.6768 6.86384 19.4058 6.86384 19.8554 7.30464L23.6002 10.9761C24.0499 11.4169 24.0499 12.1316 23.6002 12.5724C23.1506 13.0132 22.4217 13.0132 21.972 12.5724L18.2272 8.90092C17.7776 8.46012 17.7776 7.74544 18.2272 7.30464Z",
				fill: "#68DCE3"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M18.2272 2.51591C18.6768 2.95671 18.6768 3.67139 18.2272 4.11219L14.9708 7.30476C14.5212 7.74556 13.7922 7.74556 13.3426 7.30476C12.893 6.86395 12.893 6.14928 13.3426 5.70848L16.599 2.51591C17.0486 2.07511 17.7776 2.07511 18.2272 2.51591Z",
				fill: "#7B1EF2"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M21.4835 5.70854C21.9331 6.14934 21.9331 6.86402 21.4835 7.30482L18.2271 10.4974C17.7775 10.9382 17.0485 10.9382 16.5989 10.4974C16.1493 10.0566 16.1493 9.3419 16.5989 8.9011L19.8553 5.70854C20.3049 5.26774 21.0339 5.26774 21.4835 5.70854Z",
				fill: "#4C82EC"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12.8541 23.108C12.4045 23.5488 11.6755 23.5488 11.2259 23.108L7.48105 19.4365C7.03144 18.9957 7.03144 18.281 7.48105 17.8402C7.93067 17.3994 8.65964 17.3994 9.10925 17.8402L12.8541 21.5117C13.3037 21.9525 13.3037 22.6672 12.8541 23.108Z",
				fill: "#68DCE3"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M5.85289 16.2439C5.40328 16.6847 4.67431 16.6847 4.22469 16.2439L0.479832 12.5725C0.0302167 12.1317 0.0302167 11.417 0.479832 10.9762C0.929447 10.5354 1.65842 10.5354 2.10803 10.9762L5.85289 14.6477C6.30251 15.0885 6.30251 15.8031 5.85289 16.2439Z",
				fill: "#68DCE3"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M5.85289 21.0327C5.40328 20.5919 5.40328 19.8772 5.85289 19.4364L9.10929 16.2438C9.55891 15.803 10.2879 15.803 10.7375 16.2438C11.1871 16.6846 11.1871 17.3993 10.7375 17.8401L7.48109 21.0327C7.03148 21.4735 6.30251 21.4735 5.85289 21.0327Z",
				fill: "#7B1EF2"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M2.5963 17.84C2.14669 17.3992 2.14669 16.6846 2.5963 16.2438L5.8527 13.0512C6.30232 12.6104 7.03129 12.6104 7.4809 13.0512C7.93052 13.492 7.93052 14.2067 7.4809 14.6475L4.2245 17.84C3.77489 18.2808 3.04592 18.2808 2.5963 17.84Z",
				fill: "#4C82EC"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M23.6002 10.9761C24.0498 11.4169 24.0498 12.1316 23.6002 12.5724L19.8554 16.2438C19.4058 16.6846 18.6768 16.6846 18.2272 16.2438C17.7776 15.803 17.7776 15.0884 18.2272 14.6476L21.972 10.9761C22.4216 10.5353 23.1506 10.5353 23.6002 10.9761Z",
				fill: "#68DCE3"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M16.599 17.8401C17.0486 18.2809 17.0486 18.9956 16.599 19.4364L12.8542 23.1079C12.4045 23.5487 11.6756 23.5487 11.226 23.1079C10.7763 22.6671 10.7763 21.9524 11.226 21.5116L14.9708 17.8401C15.4204 17.3993 16.1494 17.3993 16.599 17.8401Z",
				fill: "#68DCE3"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M21.4835 17.8401C21.0339 18.2809 20.3049 18.2809 19.8553 17.8401L16.5989 14.6476C16.1493 14.2068 16.1493 13.4921 16.5989 13.0513C17.0485 12.6105 17.7775 12.6105 18.2271 13.0513L21.4835 16.2439C21.9331 16.6847 21.9331 17.3993 21.4835 17.8401Z",
				fill: "#7B1EF2"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M18.2272 21.0328C17.7775 21.4736 17.0486 21.4736 16.599 21.0328L13.3426 17.8402C12.8929 17.3994 12.8929 16.6847 13.3426 16.2439C13.7922 15.8031 14.5211 15.8031 14.9708 16.2439L18.2272 19.4365C18.6768 19.8773 18.6768 20.592 18.2272 21.0328Z",
				fill: "#4C82EC"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M0.479845 12.5725C0.03023 12.1317 0.0302301 11.417 0.479845 10.9762L4.22471 7.30474C4.67432 6.86394 5.40329 6.86394 5.85291 7.30474C6.30252 7.74554 6.30252 8.46022 5.85291 8.90102L2.10805 12.5725C1.65843 13.0133 0.92946 13.0133 0.479845 12.5725Z",
				fill: "#68DCE3"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M7.48107 5.70845C7.03145 5.26765 7.03145 4.55297 7.48107 4.11217L11.2259 0.440726C11.6755 -7.49489e-05 12.4045 -7.4869e-05 12.8541 0.440726C13.3037 0.881527 13.3037 1.59621 12.8541 2.03701L9.10927 5.70845C8.65965 6.14925 7.93068 6.14925 7.48107 5.70845Z",
				fill: "#68DCE3"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M2.59633 5.70845C3.04594 5.26765 3.77491 5.26765 4.22453 5.70845L7.48093 8.90101C7.93054 9.34181 7.93054 10.0565 7.48093 10.4973C7.03131 10.9381 6.30234 10.9381 5.85273 10.4973L2.59633 7.30473C2.14671 6.86393 2.14671 6.14925 2.59633 5.70845Z",
				fill: "#7B1EF2"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M5.85292 2.51582C6.30253 2.07502 7.0315 2.07502 7.48112 2.51582L10.7375 5.70839C11.1871 6.14919 11.1871 6.86387 10.7375 7.30467C10.2879 7.74547 9.55893 7.74547 9.10932 7.30467L5.85292 4.11211C5.4033 3.6713 5.4033 2.95663 5.85292 2.51582Z",
				fill: "#4C82EC"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_104_222",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24.1262,
			height: 23.5294,
			fill: "white"
		})
	}) })]
});
export default SvgLogo;
